import React, { useContext, useEffect } from 'react';
import BookerContext from '../../context/bookerContext';
import { ReactComponent as InfoIcon } from '../../assets/img/info.svg';
import BookerShortContext from '../../context/bookerShortContext';
import store from '../../store/bookerStore';
import '../../assets/styles/estimated-fare.sass';

const EstimatedFare = () => {
  const context = useContext(BookerContext);
  const {
    state: { fare: { total_amount, isExpired = false } = {}, rideLater, step, isWebBooker, isMeteredFare },
  } = context;

  const { togglePopup } = useContext(BookerShortContext);
  const key = 'fare';
  const { [key]: { isOpen: popupFareIsOpen = false } = {} } = store.getState()?.popup || {};

  const ride_fare = total_amount ? `$${(total_amount / 100).toFixed(2)}` : '';
  const ride_later_fare = rideLater?.fare_formatted || `$${rideLater?.fare}` || '';
  const isUpcomingRideStep = (isWebBooker && step === 13) || (!isWebBooker && step === 10);
  const fare = isUpcomingRideStep ? ride_later_fare : ride_fare;

  useEffect(() => {
    if (!isExpired || popupFareIsOpen) return;
    console.log('useEffect isExpired ', isExpired);
    togglePopup(true, key);
  }, [isExpired]);

  return (
    <div className={`fare-container${!total_amount ? ' fadein' : ''}`}>
      <span className={`fare-title${isMeteredFare ? ' metered-fare-title' : ''}`}>
        {isMeteredFare ? 'Est. Meter Fare:' : 'Upfront Fare:'}
      </span>
      {fare && (
        <>
          <span className={`fare-amount${isMeteredFare ? ' metered-fare-amount' : ''}`}>
            {isMeteredFare ? '~' : ''}
            {fare}
          </span>
          <div className="info-btn" onClick={() => togglePopup(true, key)}>
            <InfoIcon />
          </div>
        </>
      )}
    </div>
  );
};

export default EstimatedFare;
